import { render, staticRenderFns } from "./SupportTicketDialog.vue?vue&type=template&id=0ba318b3&scoped=true&"
import script from "./SupportTicketDialog.vue?vue&type=script&lang=js&"
export * from "./SupportTicketDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba318b3",
  null
  
)

export default component.exports